import { motion } from "framer-motion";
import { MEDIA } from "../lib/media";

const GALLERY_IMAGES = [
  { src: MEDIA.cocktail1, alt: "Cóctel especial Suchimex", span: "md:col-span-2 md:row-span-2" },
  { src: MEDIA.nachos, alt: "Nachos con ambiente festivo", span: "md:col-span-1 md:row-span-1" },
  { src: MEDIA.tacosPlatter, alt: "Tacos y aperitivos", span: "md:col-span-1 md:row-span-1" },
  { src: MEDIA.room1, alt: "La Palomar - habitación para parejas", span: "md:col-span-1 md:row-span-1" },
  { src: MEDIA.cocktail2, alt: "Bebida festiva con decoración mexicana", span: "md:col-span-1 md:row-span-1" },
  { src: MEDIA.coffePastry, alt: "Café gourmet y repostería", span: "md:col-span-2 md:row-span-1" },
];

export const GallerySection = () => {
  return (
    <section id="galeria" data-testid="gallery-section" className="py-24 md:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="overline text-[#A25F4B] mb-4">Momentos</p>
          <h2
            data-testid="gallery-title"
            className="font-heading text-4xl md:text-5xl tracking-tight text-[#2D2A26]"
          >
            Galería
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[220px]">
          {GALLERY_IMAGES.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`gallery-item ${img.span}`}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
